<template>
  <div>
    <MyBreadcrumb
      :breadcrumb-list="[
        {text:'应用列表',to:'/app/market/index'},
        {text:'订购记录',to:'/app/orderRecord/index'},
        {text:'记录详情',to:''}
      ]"
    ></MyBreadcrumb>

    <div class="page-content">
      <div
        class="form-box"
        :style="{height:contentheight+'px'}"
      >
        <div class="order-header">
          <div class="order-status-icon">
            <Icon
              size="50"
              :type="statusObj[orderStatus].icon"
              :color="statusObj[orderStatus].color"
            />
          </div>
          <div>
            <div class="order-status">
              <!-- 当订单状态为3:汇款支付中时，页面需要显示款项待核实 -->
              <span v-if="orderStatus===3 && detail.payChannel===3">款项待核实</span>
              <span v-else> {{ statusObj[orderStatus].name }}</span>
            </div>
            <!-- 订单状态为11:审核拒绝时， 页面需要显示付款方式：汇款支付，且需要有查看付款账户的入口，需要显示审核拒绝原因 -->
            <div
              v-if="orderStatus==11"
              class="sub-remark"
            >
              {{ detail.checkRemark }}
            </div>
            <!-- 待付款倒计时 -->
            <div
              v-if="orderStatus==1 && countTime>0"
              class="sub-remark"
            >
              <CountDown
                class="count-down"
                :time="countTime"
                format="mm分ss秒"
              ></CountDown>
              后关闭订单
            </div>
            <!-- 已关闭 -->
            <div
              v-if="orderStatus==7"
              class="sub-remark"
            >
              {{ detail.closeTime }} 自动关闭
            </div>
          </div>
        </div>
        <Form
          ref="form"
          :model="form.params"
        >
          <div
            class="table-section"
          >
            <div class="section-header">
              <span class="section-tip">
                <span class="detail-text">  订单编号 {{ detail.orderNo }}</span>
                <Button
                  class="span-btn"
                  type="text"
                  @click="copy"
                >复制</Button>
              </span>
              <span class="section-tip">创建时间 ：{{ detail.orderTime }}</span>
              <span
                v-if="detail.createTime"
                class="section-tip"
              >订购完成时间 ：{{ detail.createTime }}</span>
              <span
                v-if="detail.corpName"
                class="section-tip"
              >主体信息：{{ detail.corpName }}</span>
              <span
                v-if="detail.accountNo"
                class="section-tip"
              >系统账号：{{ detail.accountNo }}</span>
              <!--状态为款项待核实时  -->
              <span
                v-if="orderStatus==5"
                class="section-tip"
              >
                付款方式：{{ detail.payChannelDesc }}
              </span>
              <span
                v-else-if="detail.payChannel===3"
                class="section-tip"
              >
                <span class="detail-text"> 付款方式：{{ detail.payChannelDesc }}</span>
                <!-- paychannel是3的表示汇款支付 -->
                <Button
                  class="span-btn"
                  type="text"
                  :loading="payAccount.loading"
                  @click="payAccount.on.show"
                >查看付款账户</Button>
                <Modal
                  v-model="payAccount.visiable"
                  title="付款账户"
                  class="payAccount-detail-modal"
                >
                  <div class="payAccount-content">
                    <div class="info-item">
                      <span class="info-item-label">付款户名：</span>
                      <span class="info-item-value">{{ payAccount.detail.payAccountName }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-item-label">付款账号：</span>
                      <span class="info-item-value">{{ payAccount.detail.payAccountNo }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-item-label">付款时间：</span>
                      <span class="info-item-value">{{ payAccount.detail.transferTime }}</span>
                    </div>
                  </div>
                  <div
                    slot="footer"
                    class="payAccount-detail-footer"
                  >
                    <Button
                      type="primary"
                      @click="payAccount.visiable = false"
                    >
                      关闭
                    </Button>
                  </div>
                </Modal>
              </span>
            </div>
            <Table
              :columns="table.columns"
              :data="table.data"
            >
            </Table>
          </div>
          <div class="clearfix">
            <div class="form-bottom-right">
              <div class="total-section">
                <div
                  v-if="detail.couponFee"
                  class="couponFee"
                >
                  优惠金额：-￥{{ detail.couponFee|moneyFix }}
                </div>
                <div class="total-content">
                  <span class="total-text">支付金额：</span>
                  <span class="total-price">￥{{ detail.payFee|moneyFix }}</span>
                </div>
              </div>
              <FormItem
                v-if="orderStatus==1"
                prop="policy"
                :rules="form.rules.policy"
              >
                <Checkbox v-model="form.params.policy">
                  我已阅读并同意
                  <!-- <a>《xxxx订购协议》</a> -->
                  <a
                    :href="detail.buyProtocol"
                    download="服务订购协议"
                    target="_blank"
                  >《服务订购协议》</a>
                </Checkbox>
              </FormItem>
              <!-- 1待付款 3支付处理中 5订购成功 7已关闭 9支付失败 11审核拒绝 -->
              <Button
                v-if="orderStatus==1"
                type="primary"
                style="margin-right: 10px;"
                @click="form.on.submit"
              >
                去支付
              </Button>
              <!-- 款项待审核和待付款增加“取消订单”功能 -->
              <Button
                v-if="[1,3].includes(orderStatus)"
                type="primary"
                style="margin-right: 10px;"
                @click="cancelOrder"
              >
                取消订单
              </Button>
              <Button
                v-if="orderStatus==5 && detail.serviceUrl"
                type="primary"
                style="margin-right: 10px;"
                @click="goMyApp"
              >
                前往应用
              </Button>
              <!-- 1待开票、3开票处理中、5开票成功、7待开票 -->
              <template v-if="[1,3,7].includes(detail.invoiceStatus)&&!isFromAppPage">
                <Button
                  type="primary"
                  @click="invoice.on.show"
                >
                  我要开票
                </Button>
                <Modal
                  v-model="invoice.visiable"
                  title="开票"
                  class="invoice-modal"
                >
                  <div class="invoice-content">
                    <div>
                      请用微信或支付宝扫描二维码自助开票
                    </div>
                    <div
                      class="qrcode-section"
                    >
                      <div class="qrcode-box">
                        <vue-qr
                          class="qrcode"
                          :text="invoice.qrcode"
                          :size="200"
                        ></vue-qr>
                      </div>
                    </div>
                    <div class="invoice-notice">
                      <div class="invoice-notice-title">
                        发票须知
                      </div>
                      <p>1.申请后不支持修改；</p>
                      <p>2.本发票为增值税电子普通发票，不提供纸质发票和个人发票；</p>
                      <p>3.发票金额为实际支付金额，不包含优惠码等优惠金额；</p>
                    </div>
                  </div>
                  <div
                    slot="footer"
                    class="invoice-footer"
                  >
                    <Button
                      type="primary"
                      @click="invoice.visiable = false"
                    >
                      关闭
                    </Button>
                  </div>
                </Modal>
              </template>
              <Button
                v-else-if="detail.invoiceStatus===5"
                type="primary"
              >
                <a
                  :href="detail.invoiceUrl"
                  download="发票"
                  target="_blank"
                  style="color: #fff;"
                > 查看发票</a>
              </Button>
            </div>
          </div>
          <div
            v-if="isFromAppPage"
            style="text-align:center"
          >
            <Button
              type="primary"
              @click="goList"
            >
              返回列表
            </Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import CountDown from '@/components/CountDown';
import VueQr from 'vue-qr';
import moment from 'moment';
import {parentRouter} from '@/common/createMicroApp/utils.js';
export default {
  components: {
    CountDown,
    VueQr,
  },
  data(){
    return {
      pageFrom: '',//页面来源-目前处理了商城跳转来源
      contentheight: '',
      // 订单倒计时
      countTime: 0,
      orderStatus: 1, // 1待付款 3支付处理中 5订购成功 7已关闭 9支付失败 11审核拒绝
      // 订单状态
      statusObj: {
        1: {
          name: '待付款',
          color: '#ff660096',
          icon: 'ios-time',
        },
        3: {
          name: '支付处理中',
          color: '#5C38F8',
          icon: 'ios-clock',
        },
        5: {
          name: '订购成功',
          color: '#ff660096',
          icon: 'ios-time',
        },
        7: {
          name: '已关闭',
          color: '#999',
          icon: 'ios-stopwatch',
        } ,
        9: {
          name: '支付失败',
          color: '#5C38F8',
          icon: 'ios-clock',
        } ,
        11: {
          name: '审核拒绝',
          color: '#999',
          icon: 'ios-stopwatch',
        },
      },
      // form表单
      form: {
        params: {

        },
        rules: {
          policy: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请勾选同意协议！'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
        on: {
          submit: ()=>{
            this.$refs.form.validate((valid) => {
              if (valid) {
                const {orderNo,productCode} = this.detail;
                const {accountNo} = this.$store.state.user.userInfo;
                this.pay({
                  orderNo,
                  accountNo,
                  productCode,
                });
                // this.$router.push({
                //   path: '/pay/index',
                // });
              }
            });
          },
        },
      },
      detail: {

      },
      // 表格
      table: {
        columns: [
          {
            title: '订购服务',
            key: 'version',
            width: 260,
            render: (h,params)=>{
              const {productImage} = params.row;
              const {saleName} = this.detail;
              const html = [];
              const img = h('img',{
                style: {
                  width: '66px',
                  height: '44px',
                  verticalAlign: 'middle',
                  marginRight: '5px',
                  flexShrink: 0,
                },
                attrs: {
                  // src: require('@/assets/images/login-bg.png'),
                  src: productImage,
                },
              });
              html.push(img);
              const span = h('span',saleName);
              html.push(span);
              return h('div',{style: 'display:flex;align-items: center;padding:20px 0'},html);
            },
          },

          {
            title: '服务周期',
            key: 'servicePeriod',
          },
          {
            title: '单价',
            key: 'productPrice',
            render: (h,params)=>{
              // const {productPrice} = params.row;
              // const html = [];
              // html.push(h('span',`￥${this.$options.filters.moneyFix(productPrice)}`));
              // return html;

              const {productName,shopInfo} = params.row;
              const html = [];
              const info1 = h('div',`${productName}`);
              html.push(info1);
              if (shopInfo){
                const info2 = h('div',`门店单价 ￥${shopInfo.productPrice}`);
                html.push(info2);
              }
              return html;
            },
          },
          {
            title: '数量',
            key: 'productNum',
            render: (h,params)=>{
              const {productNum,shopInfo} = params.row;
              const html = [];
              const info1 = h('div',`x${productNum}`);
              html.push(info1);
              if (shopInfo){
                const info2 = h('div',`x${shopInfo.productNum}`);
                html.push(info2);
              }
              return html;
            },
          },
          {
            title: '价格',
            key: 'productTotal',
            render: (h,params)=>{
              const {shopInfo} = params.row;
              let {productTotal} = params.row;
              if (shopInfo){
                productTotal +=shopInfo.productTotal;
              }
              const html = [];
              html.push(h('span',`￥${this.$options.filters.moneyFix(productTotal)}`));
              return html;
            },
          },
        ],
        data: [
          // {
          //   version: '营销工具特惠版本限时抢购',
          //   type: '试用版',
          //   period: '7天',
          //   price: '￥9600.00',
          // },
        ],
      },
      coupons: {
        couponsPrice: '100',
      },
      // 付款账户明细弹框
      payAccount: {
        visiable: false,
        loading: false,
        detail: {},
        on: {
          show: ()=>{
            const {orderNo} = this.detail;
            // const url = '/paycenter-charge/api/facade/order/transfer';
            const url = '/paycenter-charge/api/worktable/order/transfer';
            const params = {
              orderNo,
            };
            this.payAccount.loading = true;
            this.$http.get(url,params).then(res=>{
              this.payAccount.loading = false;
              this.payAccount.visiable = true;
              if (res.success){
                this.payAccount.detail = res.data;
              } else {
                this.$Message.warning(res.message||'获取失败');
              }
            });

          },
        },
      },
      // 开票弹框
      invoice: {
        visiable: false,
        qrcode: '',
        on: {
          show: ()=>{
            const {orderNo} = this.detail;
            // 1待开票、3开票处理中、5开票成功、7待开票
            // if (invoiceStatus===3){
            //   this.$Message.warning('正在开票中，请稍后等待');
            //   return;
            // }
            const url = '/paycenter-charge/api/worktable/invoice/apply';
            const params = {
              orderNo,
            };
            this.$http.get(url,params).then(res=>{
              if (res.success){
                this.invoice.qrcode = res.data;
                this.invoice.visiable = true;
              } else {
                this.$Message.warning(res.message||'请求失败');
              }
            });

          },
        },
      },
    };
  },
  computed: {
    isFromAppPage(){
      return ['distributionChannels'].includes(this.pageFrom);
    },
    totalPrice(){
      // 总价格
      let totalPrice = '';

      // 优惠价格
      const {couponsPrice} = this.coupons;

      totalPrice =10200+Number(couponsPrice||0);
      return totalPrice;
    },
  },
  created(){
    // 获取详情
    this.getDetail();

    this.pageFrom =sessionStorage.getItem('pageFrom')??'';
  },
  mounted() {
    this.contentheight = window.innerHeight - 170;
  },
  methods: {
    goList(){
      parentRouter({
        path: '/vapplication/distributionChannels',
      });
    },
    // 取消订单
    cancelOrder(){
      this.$Modal.confirm({
        title: '取消订单',
        content: ' 确认取消订单？',
        onOk: () => {
          const {orderNo} = this.$route.query;
          // const url = '/paycenter-charge/api/facade/order/detail';
          const url = '/paycenter-charge/api/worktable/close/order';
          const params = {
            orderNo,
          };
          this.$http.post(url,params).then(res=>{
            if (res.success){
              // 获取详情
              this.getDetail();
            } else {
              this.$Message.warning(res.message||'获取详情失败');
            }
          });
        },
      });


    },
    // 前往我的应用
    goMyApp(){
      const {serviceUrl} = this.detail;
      // window.open(serviceUrl,'_blank');
      window.location.href = serviceUrl;
      // window.location.href = serviceUrl;
      // this.$router.push({
      //   path: '/app/market/index',
      //   query: {
      //     appType: 'myApp',
      //   },
      // });
    },
    // 获取详情
    getDetail(){
      const {orderNo} = this.$route.query;
      const {corpCode} = this.$store.state.user.userInfo;
      // const url = '/paycenter-charge/api/facade/order/detail';
      const url = '/paycenter-charge/api/worktable/order/detail';
      const params = {
        orderNo,
        corpCode,
      };
      this.$http.get(url,params).then(res=>{
        if (res.success){

          this.detail = res.data;
          this.orderStatus = this.detail.orderStatus || 1;
          const {payExpireTime} = this.detail;
          this.countTime = (moment(payExpireTime).unix()-moment().unix())*1000;
          // this.orderStatus = 1;
          //
          const {detailList} = res.data;
          if (detailList && detailList.length){
            let shopInfo = '';
            if (detailList[1]){
              shopInfo = detailList[1];
            }
            this.table.data = [
              {
                ...detailList[0],
                shopInfo,
              },
            ];
          }
        } else {
          this.$Message.warning(res.message||'获取详情失败');
        }
      });
    },
    // 复制
    copy(){
      const {orderNo} = this.detail;
      this.$copyText(orderNo).then(
        () => {
          this.$Message.success('复制成功！');
        },
        () => {
          this.$Message.error('复制失败！');
        },
      );
    },
  },
};
</script>
<style lang="less" scoped>
.page-content {
  background-color: #fff;
}
.form-box {
  padding: 10px 40px 20px;
  min-height: 100%;
}
.table-section {
  // width: 700px;
  box-sizing: border-box;
  margin: 0 auto 20px;
  .section-header {
    margin-bottom: 10px;
  }
  .section-name {
    font-weight: bold;
    font-size: 18px;
    margin-right: 10px;
  }
  .section-tip {
    color: #666;
    font-size: 13px;
    margin-right: 30px;
    display: inline-block;
    vertical-align: middle;
  }
  .span-btn {
    color: #409eff;
    cursor: pointer;
    padding: 0;
    vertical-align: middle;
    margin-left: 5px;
  }
  .detail-text {
    display: inline-block;
    vertical-align: middle;
  }
}
.total-section {
  .couponFee {
    color: #f00;
  }
  .total-content {
    padding: 10px 0;
  }
  .total-text {
    font-weight: bold;
    color: #333;
  }
  .total-price {
    font-weight: bold;
    color: #f00;
    margin-right: 10px;
    font-size: 16px;
  }
  .total-detail {
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
  }
}
.form-bottom-right {
  float: right;
}
.order-header {
  display: flex;
  padding: 0 0 10px;
  align-items: center;
  .sub-remark {
    font-size: 12px;
    color: #999;
  }
  .count-down {
    display: inline-block;
  }
  .order-status-icon {
    margin-right: 10px;
  }
  .order-status {
    font-size: 16px;
    font-weight: bold;
  }
}
.payAccount-detail-modal {
  .info-item {
    padding: 5px 0;
  }
  .info-item-value {
    color: #999;
    display: inline-block;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    padding: 5px 10px;
    width: 300px;
  }
  .payAccount-content {
    width: 380px;
    margin: 0 auto;
  }
  .payAccount-detail-footer {
    text-align: center;
  }
}
.invoice-modal {
  .invoice-content {
    // width: 380px;
    // margin: 0 auto;
    text-align: center;
  }
  .invoice-footer {
    text-align: center;
  }
  .invoice-notice-title {
    font-weight: bold;
  }
  .invoice-notice {
    text-align: left;
    padding-left: 50px;
    // width: 380px;
    // margin: 0 auto;
  }
}
</style>
